export type Procedure = (...args: any[]) => void;

// eslint-disable-next-line func-names
export default function <F extends Procedure> (func: F, waitMilliseconds = 50, isImmediate?: boolean): F {
  let timeoutId: any;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return function debounce(this: any, ...args: any[]) {
    const context = this; // eslint-disable-line @typescript-eslint/no-this-alias,@typescript-eslint/no-unsafe-assignment

    const doLater = function doLater(): void {
      timeoutId = undefined;
      if (!isImmediate) {
        func.apply(context, args);
      }
    };

    const shouldCallNow = isImmediate && timeoutId === undefined;

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(doLater, waitMilliseconds);

    if (shouldCallNow) {
      func.apply(context, args);
    }
  } as any;
}
